import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGeniusComponent } from './simple-icons-genius.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGeniusComponent ],
    exports:      [ SimpleIconsGeniusComponent ],
    bootstrap:    []
})
export class SimpleIconsGeniusModule {}
